'use client';

import {ShieldCheck} from 'lucide-react';
import {securityContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderLight, sectionPadding, SectionContainer, SectionHeader} from './shared';

export function SecuritySection() {
  return (
    <section id={securityContent.id} aria-labelledby="security-heading" className={`${sectionPadding} bg-white ${sectionBorderLight} relative`}>
      <SectionContainer>
        <FadeIn>
          <SectionHeader badge="Seguridad" title={securityContent.title} description={securityContent.description} />
        </FadeIn>

        <FadeIn delay={0.1}>
          <div className="flex flex-wrap justify-center gap-2 -mt-8 mb-12" aria-label="Estándares de seguridad">
            {securityContent.highlights.map((item) => (
              <span
                key={item}
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-kobra-accent bg-kobra-accent-soft border border-kobra-accent/20 px-3 py-1.5 rounded-full"
              >
                <ShieldCheck className="w-3.5 h-3.5" aria-hidden="true" />
                {item}
              </span>
            ))}
          </div>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {securityContent.cards.map((card, index) => {
            const Icon = card.icon;
            return (
              <FadeIn key={card.title} delay={index * 0.1} className="h-full">
                <article className={`h-full bg-kobra-bg border border-kobra-border rounded-2xl p-6 hover:border-kobra-accent/40 ${cardHoverClass}`}>
                  <div className="w-11 h-11 bg-kobra-accent-soft rounded-full flex items-center justify-center mb-4">
                    <Icon className="w-5 h-5 text-kobra-accent" aria-hidden="true" />
                  </div>
                  <h3 className="font-bold text-kobra-text-dark mb-3">{card.title}</h3>
                  <ul className="space-y-1.5">
                    {card.items.map((item) => (
                      <li key={item} className="text-sm text-kobra-text-muted leading-snug">
                        {item}
                      </li>
                    ))}
                  </ul>
                </article>
              </FadeIn>
            );
          })}
        </div>
      </SectionContainer>
    </section>
  );
}
